import React, { useMemo } from 'react'
import { Flex } from 'theme-ui'
import { useResponsiveValue } from '@theme-ui/match-media'

import {
  SectionContainerStyled,
  SectionContentStyled,
  SectionMediaStyled,
  SectionButtonListStyled,
  SectionButtonListItemStyled
} from './styles'
import Section from './../Section/index'
import Heading from './../../molecules/Heading'
import Button from './../../atoms/Button'
import MediaItem from './../../molecules/MediaItem'

import { DownloadOurAppProps } from './types'

const DownloadOurAppSection: React.FC<DownloadOurAppProps> = ({
  id,
  heading,
  isHeadingGreen,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,
  data
}) => {
  const isDesktop = useResponsiveValue([false, false, true, true], {
    defaultIndex: 0
  })

  const { media, content, buttons } = data

  const buttonsContainer = useMemo(
    () => (
      <SectionButtonListStyled>
        {buttons?.map((button, index) => (
          <SectionButtonListItemStyled key={`section-button-${index}`}>
            <Button {...button} variant="withIcon" />
          </SectionButtonListItemStyled>
        ))}
      </SectionButtonListStyled>
    ),
    [buttons]
  )

  return (
    <Section
      {...{
        id,
        inner,
        paddingTop,
        paddingBottom,
        headingPadding,
        bgColor,
        heading,
        isHeadingGreen,
        subheading,
        description,
        data
      }}
      body={
        <>
          <SectionContainerStyled>
            <SectionContentStyled>
              <Flex>
                <Heading title={content.title} subtitle={content.subtitle} />
              </Flex>
              {isDesktop && buttons ? buttonsContainer : ''}
            </SectionContentStyled>
            {media && <SectionMediaStyled>{media.image || media.video ? <MediaItem {...{ media }} /> : ''}</SectionMediaStyled>}
            {!isDesktop && buttons ? buttonsContainer : ''}
          </SectionContainerStyled>
        </>
      }
    />
  )
}

export default DownloadOurAppSection
